/* Renewal Hub - Main entry point for policy renewals at /renew */

import React from "react";
import { useLocation } from "react-router-dom";
import GenericSelectPoliciesPage from "./components/GenericSelectPoliciesPage";

const RenewalHub = () => {
  const location = useLocation();

  // Use location.key to force complete remount of GenericSelectPoliciesPage
  // This ensures fresh state when navigating back from any renewal flow
  return (
    <div className="mainCarDetailsModal pt-[1%] pb-[5%] max767:w-full max767:overflow-y-scroll max767:pb-[30%] max767:h-screen max767:pt-0 ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll">
      <GenericSelectPoliciesPage key={location.key} />
    </div>
  );
};

export default RenewalHub;
